/**
 * Mapea la respuesta cruda del OCR al objeto que consume el resto del registro.
 *
 * Vive fuera del componente porque es una funcion pura y porque una de sus
 * reglas produce un dato regulatorio: la nacionalidad que se declara ante el
 * backend. Ver `nationality` mas abajo.
 */
export function mapOcrResult(result: any, documentType: string): any {
  if (documentType === 'chile') {
    return {
      firstName: result.campos?.nombres || '',
      lastName: result.campos?.apellidos || '',
      fullName: `${result.campos?.nombres || ''} ${result.campos?.apellidos || ''}`.trim(),
      documentNumber: result.campos?.run || '',
      documentNumberClean: result.campos?.runSinFormato || '',
      RUN: result.campos?.run || result.campos?.runSinFormato || '',
      // country/countryName son el pais QUE EMITIO el documento.
      // No son la nacionalidad ni la residencia del titular.
      country: 'CHL',
      countryName: 'Chile',
      documentType: result.tipoDocumento || 'Cedula de Identidad',
      confidenceScore: result.validacion?.confianzaOCR || 0,
      // La nacionalidad sale UNICAMENTE del OCR. Si el documento no la trae,
      // queda vacia y la elige el usuario: un RUT chileno no implica ser chileno.
      nationality: result.campos?.nacionalidad || '',
      gender: result.campos?.sexo || '',
      fechaNacimientoISO: result.campos?.fechaNacimientoISO || '',
      issueDate: result.campos?.fechaEmisionISO || '',
      expirationDate: result.campos?.fechaVencimientoISO || '',
      isExpired: result.validacion?.estaVencido || false,
      daysUntilExpiration: result.validacion?.diasHastaVencimiento || 0,
      fotoPersona: result.fotoPersona || '',
      isValid: result.validacion?.runValido && !result.validacion?.estaVencido,
      warnings: result.validacion?.advertencias || [],
      sanctionsCheck: result.verificacionSanciones,
      hasSanctionsRisk: result.verificacionSanciones?.hasMatches || false,
    };
  } else if (documentType === 'venezuela') {
    return {
      firstName: result.campos?.nombres || '',
      lastName: result.campos?.apellidos || '',
      fullName: `${result.campos?.nombres || ''} ${result.campos?.apellidos || ''}`.trim(),
      documentNumber: result.campos?.numeroCedula || '',
      documentNumberClean: result.campos?.numeroCedulaSinFormato || '',
      RUN: result.campos?.numeroCedulaSinFormato || '',
      // Ver nota en la rama de Chile: es el emisor, no el titular.
      country: 'VEN',
      countryName: 'Venezuela',
      documentType: result.tipoDocumento || 'Cedula de Identidad',
      confidenceScore: result.validacion?.confianzaOCR || 0,
      // La nacionalidad sale UNICAMENTE del OCR. Si el documento no la trae,
      // queda vacia y la elige el usuario: una cedula venezolana no implica
      // ser venezolano (existe la cedula "E" de extranjero).
      nationality: result.campos?.nacionalidad || '',
      gender: result.campos?.sexo || '',
      fechaNacimientoISO: result.campos?.fechaNacimientoISO || '',
      issueDate: result.campos?.fechaExpedicionISO || '',
      expirationDate: result.campos?.fechaVencimientoISO || '',
      isExpired: result.validacion?.estaVencido || false,
      daysUntilExpiration: result.validacion?.diasHastaVencimiento || 0,
      fotoPersona: result.fotoPersona || '',
      civilStatus: result.campos?.estadoCivil || '',
      expeditionNumber: result.campos?.numeroExpedicion || '',
      documentPrefix: result.campos?.tipoCedula || '',
      isValid: result.validacion?.cedulaValida && !result.validacion?.estaVencido,
      warnings: result.validacion?.advertencias || [],
      sanctionsCheck: result.verificacionSanciones,
      hasSanctionsRisk: result.verificacionSanciones?.hasMatches || false,
    };
  }

  // Default mapping
  return {
    firstName: result.campos?.nombres || result.firstName || '',
    lastName: result.campos?.apellidos || result.lastName || '',
    documentNumber: result.campos?.numeroDocumento || result.documentNumber || '',
    country: result.pais || '',
    documentType: result.tipoDocumento || '',
    confidenceScore: result.validacion?.confianzaOCR || 0,
  };
}
